import { jsxs as a, jsx as n } from "react/jsx-runtime";
import { c } from "../../../../clsx-OuTLNxxd.js";
import { forwardRef as d } from "react";
const x = "_container_1iybi_29", y = "_message_1iybi_33", h = "_error_1iybi_39", u = "_disabled_1iybi_49", e = {
  container: x,
  message: y,
  error: h,
  "input-container": "_input-container_1iybi_43",
  disabled: u,
  "checkbox-input": "_checkbox-input_1iybi_52",
  "label-container": "_label-container_1iybi_99"
}, k = d(
  ({ label: o, value: t, onChange: l, name: _, message: r, hasError: s, disabled: i, checked: b }, m) => {
    const p = c(e["checkbox-input"], s && e.error, i && e.disabled);
    return /* @__PURE__ */ a("div", { className: e.container, children: [
      /* @__PURE__ */ a("label", { className: c(e["input-container"], i && e.disabled), children: [
        /* @__PURE__ */ n(
          "input",
          {
            type: "checkbox",
            className: p,
            name: _,
            value: t,
            onChange: l,
            disabled: i,
            checked: b,
            ref: m
          }
        ),
        /* @__PURE__ */ n("div", { className: e["label-container"], children: o })
      ] }),
      r && /* @__PURE__ */ n("span", { className: c(e.message, s && e.error), children: r })
    ] });
  }
);
k.displayName = "Checkbox";
export {
  k as Checkbox
};
